/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_ShouldersInputs */

const en_us2_body_measures_how_shoulders = /** @type {(inputs: Body_Measures_How_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Around the widest part, over the shoulders. Standing, arms loose at your sides, at the end of a normal breath out.`)
};

const pt_br2_body_measures_how_shoulders = /** @type {(inputs: Body_Measures_How_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais larga, passando sobre os ombros. Em pé, braços soltos ao lado do corpo, ao fim de uma expiração normal.`)
};

const es_419_body_measures_how_shoulders = /** @type {(inputs: Body_Measures_How_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la parte más ancha, pasando sobre los hombros. De pie, brazos sueltos a los costados, al final de una exhalación normal.`)
};

const pt_pt2_body_measures_how_shoulders = /** @type {(inputs: Body_Measures_How_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais larga, a passar por cima dos ombros. De pé, braços soltos ao lado do corpo, no fim de uma expiração normal.`)
};

const fr_fr2_body_measures_how_shoulders = /** @type {(inputs: Body_Measures_How_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au plus large, en passant sur les épaules. Debout, bras relâchés le long du corps, à la fin d'une expiration normale.`)
};

const de_de2_body_measures_how_shoulders = /** @type {(inputs: Body_Measures_How_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An der breitesten Stelle, über die Schultern hinweg. Im Stehen, Arme locker seitlich am Körper, am Ende einer normalen Ausatmung.`)
};

const it_it2_body_measures_how_shoulders = /** @type {(inputs: Body_Measures_How_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel punto più largo, passando sopra le spalle. In piedi, braccia rilassate lungo i fianchi, alla fine di una normale espirazione.`)
};

/**
* | output |
* | --- |
* | "Around the widest part, over the shoulders. Standing, arms loose at your sides, at the end of a normal breath out." |
*
* @param {Body_Measures_How_ShouldersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_shoulders = /** @type {((inputs?: Body_Measures_How_ShouldersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_ShouldersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_shoulders(inputs)
	if (locale === "es-419") return es_419_body_measures_how_shoulders(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_shoulders(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_shoulders(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_shoulders(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_shoulders(inputs)
	return en_us2_body_measures_how_shoulders(inputs)
});
export { body_measures_how_shoulders as "body-measures.how_shoulders" }